"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    STATUS: {
        PLAY: 'PLAY',
        PAUSE: 'PAUSE',
        STOP: 'STOP'
    },
    VOLUME: {
        STATUS: {
            MUTE: 'MUTE',
            UNMUTE: 'UNMUTE'
        },
        DEFAULT_VALUE: 100
    }
};
//# sourceMappingURL=player.js.map